export const colors={
    PRYMARY:"#49599f",
    SECONDARY:"#747474",
    TERTIARY:"#E8E8E8",
    BACKGROUND:"#FFFFFF",
    BACKGROUND2:"unset",
    BACKGROUND3: "#f4faff",
    RED: "#E72424",
    GREEN:"#009d43;",
}

